import { useState } from "react";
import { useAtomValue } from "jotai";
import { Button } from "@zapier/design-system-beta";
import { Alert, AlertDescription, Icon, Text } from "@zapier/design-system";
import { togglesAtomResettable } from "@zapier/canvas-state";
import styles from "./WhatsNewAlert.module.css";
import dynamic from "next/dynamic";

const DISMISSED_KEY = "whats-new-alert-dismissed";

function WhatsNewAlertComponent() {
  const toggles = useAtomValue(togglesAtomResettable);
  const URL = toggles.showWhatsNewAlert.config.url;

  const [isVisible, setIsVisible] = useState(
    !localStorage.getItem(DISMISSED_KEY),
  );

  const handleDismiss = () => {
    localStorage.setItem(DISMISSED_KEY, "true");
    setIsVisible(false);
  };

  const handleWhatsNewClick = () => {
    window.open(URL, "_blank");
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className={styles.whatsNewWrapper}>
      <Alert onDismiss={handleDismiss} status="info" variant="toast">
        <AlertDescription>
          <Text type="Body3">
            {
              "We're refreshing Canvas with a cleaner, more intuitive look—rolling out next week."
            }
          </Text>
          <div className={styles.buttonWrapper}>
            <Button
              variant="primary"
              size="small"
              onPress={handleWhatsNewClick}
            >
              {`See what's coming`}
              <Icon name="arrowBigRight" size="small" />
            </Button>
          </div>
        </AlertDescription>
      </Alert>
    </div>
  );
}

export const WhatsNewAlert = dynamic(
  () => Promise.resolve(WhatsNewAlertComponent),
  {
    ssr: false,
  },
);
